<template>
  <div class="add-tag-container">
    <DialogWrapper
      closeOnCancel
      ref="addCandidateTagDialog"
      class="add-candidate-tag-dialog"
      saveBtnLabelI18nKey="common.btn.add"
      :show.sync="show"
      :loading="loading"
      :title="$t(`${i18nPrefix}.title.addTag`)"
      @save="handleSaveClick"
    >
      <div class="content">
        <el-select
          v-model="selectTag"
          :placeholder="$t(`${i18nPrefix}.placeholder.selectTag`)"
          filterable
          multiple
          ref="tagSelector"
          class="job-selector"
        >
          <el-option
            v-for="item in tagList.manual"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import DialogWrapper from '../../../../components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    applicationList: {
      required: false
    },
    isTalentPool: {
      type: Boolean,
      default: false
    },
    candidateList: {
      required: false
    },
    isAllApplication: {
      required: false
    },
    searchParams: {
      required: false
    },
    jobId: {
      required: false
    },
    candidateType: {
      default: 'candidate'
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      show: false,
      loading: false,
      errorMessage: null,
      selectTag: [],
      tagList: {
        manual: [],
        smart: []
      }
    }
  },
  computed: {
    hasCRMTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    }
  },
  created () {
  },
  methods: {
    ...mapActions('crm', ['searchTag', 'addCandidateTag']),
    async showDialog () {
      this.selectTag = []
      this.show = true
      await this.loadTagList()
    },
    async loadTagList () {
      if (!this.hasCRMTagPermission) {
        return
      }
      await this.$nextTick()
      const params = {
        is_company_tag: 1,
        tag_category: ['smart', 'manual'].join(',')
      }
      if (this.candidateList && this.candidateList.length === 1) {
        params.hide_tag_from_candidate = this.candidateList[0]
      }
      const resp = await this.searchTag(params)
      if (resp) {
        this.tagList = _.groupBy(resp, 'category')
      }
    },
    async handleSaveClick () {
      if (this.loading) {
        return
      }
      this.errorMessage = null
      const params = {
        job_id: this.jobId,
        search_params: this.searchParams,
        is_all_application: this.isAllApplication,
        tag_id_list: this.selectTag,
        candidate_type: this.candidateType,
        is_talent_pool: this.isTalentPool,
        candidate_list: this.candidateList
      }
      this.loading = true
      try {
        const resp = await this.addCandidateTag(params)
        if (resp && resp.status === 'success') {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.addTag.success`))
          this.$emit('success')
          this.show = false
        } else {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.addTag.failed`))
        }
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
</style>
